var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripeSIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#646FDE",
    d: "M11.106,18.592c-2.215,0-5.077-0.914-7.324-2.133v6.022C6.269,23.55,8.793,24,11.102,24c5.564,0,9.398-2.39,9.398-7.198c0-7.976-10.229-6.547-10.229-9.556L10.27,7.245c0-1.045,0.873-1.448,2.271-1.448c2.036,0,4.621,0.623,6.658,1.72V1.223C16.981,0.337,14.766,0,12.547,0C7.118,0,3.5,2.83,3.5,7.564c0,7.401,10.173,6.201,10.173,9.392C13.673,18.194,12.599,18.592,11.106,18.592z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeSIc);
export default __webpack_public_path__ + "static/media/stripe_s_ic.5037c8d7e55e9dcee995117b4759f4e0.svg";
export { ForwardRef as ReactComponent };